import { memo } from "react";
import { FlagsProvider } from "flagged";
import { FEATURE_FLAGS } from "@app/featureFlags";

/*
Our implentation for FeatureFlags Provider.
we're using 4 layers to determine if something is active.
1. Defaults - from src/featureFlags
2. Online service (w/ DB) - TBD
3. Online - after login
4. SessionStorage

each level overrides previous ones. i.e. - if something is defined by sessionStorage then it will decide if it's on or off.

SessionStorage example:
on console:
  sessionStorage.INTERCOM_PLUGIN = false

  -- refresh the page and intercom will be off --
*/

const defaultFeatureFlags = Object.entries(FEATURE_FLAGS).reduce((res, [key, item]) => { res[key] = item.value; return res; }, {});

const FeatureFlagSessionOverrides = (featureFlags) => Object.keys(featureFlags).reduce((res, key) => {
  let fromSessionStorage;
  try {
    fromSessionStorage = JSON.parse(sessionStorage.getItem(key));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn(`failed to parse sessionStorage for key ${key}`);
  }
  
  res[key] = fromSessionStorage != null ? fromSessionStorage : featureFlags[key];
  return res;
}, {});

const FeatureFlagsProvider = (props) => {
  const { children } = props;

  const featureFlagsResult = FeatureFlagSessionOverrides(defaultFeatureFlags);
  sessionStorage.setItem("flags", JSON.stringify(defaultFeatureFlags));
  window.APP_FEATURE_FLAGS = featureFlagsResult;

  return (
    <FlagsProvider features={featureFlagsResult}>
      {children}
    </FlagsProvider>
  );
};


export default memo(FeatureFlagsProvider);
